module.exports = __webpack_public_path__ + "static/img/logoAb2.24825392.png";